// Could be good to add a hover state for the file upload button for dropzone

class FormValidation extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.className = this.getAttribute('data-class')

    this.checkRequiredState()
  }

  setupListeners () {
    super.setupListeners()

    if (this?.els?.required?.exists && this?.els?.submit?.exists) {
      this.els.required.elements.forEach(requiredEl => {
        this.listeners.add(
          requiredEl,
          'input',
          this.checkRequiredState.bind(this),
        )
      })
    }

    if (this.els.select?.exists) {
      this.els.select.elements.forEach(selectEl => {
        this.listeners.add(
          selectEl,
          'change',
          this.handleSelectChange.bind(this),
        )
      })
    }

    if (this.els.file?.exists) {
      this.els.file.elements.forEach(fileEl => {
        this.listeners.add(
          fileEl,
          'change',
          this.handleFileChange.bind(this),
        )
      })
    }

    if (this.els.optIn?.exists) {
      this.listeners.add(
        this.els.optIn.element,
        'change',
        this.handleOptInChange.bind(this),
      )
    }
  }

  handleSelectChange (event) {
    const selectEl = event.target

    if (selectEl.selectedIndex === 0) {
      selectEl.classList.remove(`${this.className}Select-selected`)
    } else {
      selectEl.classList.add(`${this.className}Select-selected`)
    }
  }

  handleFileChange (event) {
    const fileEl = event.target

    if (fileEl.files.length === 0) {
      fileEl.parentNode.classList.remove(`${this.className}FileMore-selected`)
      fileEl.parentNode.classList.remove(`${this.className}FileSingle-selected`)
      return
    } else if (fileEl.files.length > 1) {
      fileEl.parentNode.classList.remove(`${this.className}FileSingle-selected`)
      fileEl.parentNode.classList.add(`${this.className}FileMore-selected`)
    } else {
      fileEl.parentNode.classList.remove(`${this.className}FileMore-selected`)
      fileEl.parentNode.classList.add(`${this.className}FileSingle-selected`)
    }

    fileEl.parentNode.querySelector('[data-file-count]').innerHTML = fileEl.files.length
  }

  handleOptInChange (event) {
    const optInEl = event.target

    const parent = document.querySelector(`.${this.className}OptIn`)

    if (optInEl.checked) {
      parent.classList.add(`${this.className}OptIn-checked`)
    }
    else {
      parent.classList.remove(`${this.className}OptIn-checked`)
    }
  }

  checkRequiredState () {
    let allAreFilled = true

    if (!this.els.required?.exists || !this.els.submit?.exists) return

    this.els.required.elements.every(requiredEl => {
      if (requiredEl.type === 'text' && requiredEl.value.length === 0) {
        allAreFilled = false

        return false
      }

      if (requiredEl.type === 'email') {
        if (requiredEl.value.length === 0 || !requiredEl.validity.valid) {
          allAreFilled = false

          return false
        }
      }

      if (requiredEl.type === 'file' && requiredEl.files.length === 0) {
        allAreFilled = false

        return false
      }

      if (requiredEl.tagName.toLowerCase() === 'select' && requiredEl.selectedIndex === 0) {
        allAreFilled = false

        return false
      }

      return true
    })

    // Uncomment if you want to disable the submit button.
    // this.els.submit.element.ariaDisabled = !allAreFilled
    // this.els.submit.element.disabled = !allAreFilled
  }
}

customElements.define('form-validation', FormValidation)
